const
  NAME               = 'socialButtons',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const SOCIAL_ICONS_TEMPLATE = `
  <a title="facebook" class="voc-social-btn voc-facebook-share" data-voc-social-sharer="facebook">
    <i class="voc-icons facebook"></i>
  </a>
  <a title="twitter" class="voc-social-btn voc-twitter-share" data-voc-social-sharer="twitter">
    <i class="voc-icons twitter"></i>
  </a>
  <a title="whatsapp" class="voc-social-btn voc-whatsapp-share hidden-lg hidden-md hidden-sm" data-voc-social-sharer="whatsapp">
    <i class="voc-icons whatsapp"></i>
  </a>
  <input type="checkbox" id="moreSocialMedia" class="voc-input-media">
  <label for="moreSocialMedia" class="voc-social-btn voc-more-share">
    <i class="voc-icons dots"></i>
  </label>
  <div class="voc-more-social">
    <a title="Google +" class="voc-social-btn voc-googleplus-share" data-voc-social-sharer="googleplus">
      <i class="voc-icons googleplus"></i>
    </a>
    <a title="linkedin" class="voc-social-btn voc-linkedin-share" data-voc-social-sharer="linkedin">
      <i class="voc-icons linkedin"></i>
    </a>
    <a class="voc-social-btn voc-mail-share" data-voc-social-sharer="mail">
      <i class="voc-icons mail"></i>
    </a>
  </div>
`;

class SocialButtons {
  constructor(element$) {
    let url = element$.data('voc-social-buttons');

    element$.html(SOCIAL_ICONS_TEMPLATE).find('[data-voc-social-sharer]').socialSharer({url});
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new SocialButtons($(this));
    });
  }

}

$.fn[NAME]             = SocialButtons._jQueryInterface;
$.fn[NAME].Constructor = SocialButtons;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return SocialButtons._jQueryInterface;
};

export default SocialButtons;



// WEBPACK FOOTER //
// ./src/plugins/social-buttons.js